import React from 'react';
import EAChip from '../../../shared/Chip/EAChip';
import { MdAccessTimeFilled } from "react-icons/md";
import ExerciseStatusChips from './ExerciseStatusChips';
import { Exercise } from "../../../../models/Exercise";

interface IProps {
  exercise: Exercise;
}

const ExerciseImageHeader: React.FC<IProps> = ({ exercise }) => {
  // Calculate duration
  const durationMinutes = Math.round((exercise.closeTime - exercise.startTime) / 60000);
  const duration = `${durationMinutes} min`;

  // Calculate status chips values
  const totalReserved = exercise.reserved + exercise.prereservation;
  const availableSpots = exercise.capacity - totalReserved;
  const percentageAvailable = exercise.capacity > 0 ? (availableSpots / exercise.capacity) * 100 : 0;
  const hasNoSpaces = availableSpots <= 0;
  const hasLastSpaces = percentageAvailable < 20 && percentageAvailable > 0;
  const hasWaitlistAvailable = hasNoSpaces && exercise.waitListQuantity > 0;

  // Check if image exists
  const hasImage = exercise.eventMessage && exercise.eventMessage.length > 10;

  // Split exercise name into words for placeholder
  const nameWords = exercise.name.split(" ");

  return (
    <div className="exercise-image-header">
      {hasImage ? (
        <div className="exercise-image-header__background" style={{ backgroundImage: `url(${exercise.eventMessage})` }}>
          <div className="exercise-image-header__overlay" />
          <div className="exercise-image-header__content">
            <h5 className="exercise-image-header__title">{exercise.name}</h5>
            <div className="exercise-image-header__chips">
              <EAChip label={exercise.exerciseGroup?.displayName || ""} />
              <EAChip label={duration} icon={<MdAccessTimeFilled />} />
            </div>
            <div className="exercise-image-header__status-chips">
              <ExerciseStatusChips
                availableSpots={availableSpots}
                capacity={exercise.capacity}
                hasNoSpaces={hasNoSpaces}
                hasLastSpaces={hasLastSpaces}
                hasWaitlistAvailable={hasWaitlistAvailable}
                assignedStatus={exercise.assigned}
                waitList={exercise.waitList}
                waitListPosition={exercise.waitListPosition}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="exercise-image-header__placeholder">
          <div className="exercise-image-header__placeholder-name" lang="pl">
            {nameWords.map((word, index) => (
              <span key={index} className="exercise-image-header__placeholder-word">
                {word}
              </span>
            ))}
          </div>
          <div className="exercise-image-header__content">
            <h5 className="exercise-image-header__title">{exercise.name}</h5>
            <div className="exercise-image-header__chips">
              <EAChip label={exercise.exerciseGroup?.displayName || ""} />
              <EAChip label={duration} icon={<MdAccessTimeFilled />} />
            </div>
            <div className="exercise-image-header__status-chips">
              <ExerciseStatusChips
                availableSpots={availableSpots}
                capacity={exercise.capacity}
                hasNoSpaces={hasNoSpaces}
                hasLastSpaces={hasLastSpaces}
                hasWaitlistAvailable={hasWaitlistAvailable}
                assignedStatus={exercise.assigned}
                waitList={exercise.waitList}
                waitListPosition={exercise.waitListPosition}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExerciseImageHeader;
